import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/w/employees')({
  staticData: { breadcrumb: 'Employees', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEES' },
  component: EmployeesLayout,
});

function EmployeesLayout() {
  return <Outlet />;
}
